<div (click)="$event.stopPropagation()">
  <mat-form-field appearance="fill" class="full-width-input">
    <input
      #languageInput
      matInput
      [ngModel]="languageFilter()"
      (ngModelChange)="languageFilter.set($event)"
      placeholder="Filter..." />
  </mat-form-field>
  <div class="language-list">
    @for (lang of filteredLanguages(); track trackByLang($index, lang)) {
    <button mat-menu-item (click)="onSelect(lang.key)">
      <span class="menu-language-row">
        <span class="menu-language-name">{{ lang.name | titlecase }}</span>
        <span class="menu-language-code">{{ lang.key | uppercase }}</span>
      </span>
    </button>
    }
  </div>
</div>
